import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";
import { colors } from "../../theme/colors";

export const TabsContainer = styled(Box)({
  display: "flex",
  borderBottom: `1px solid ${colors.border.light}`,
  marginBottom: "24px",
});

export const TabButton = styled(Button)<{ "data-active"?: boolean }>(
  ({ "data-active": isActive }) => ({
    padding: "12px 24px",
    textTransform: "none",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    color: isActive ? colors.primary.main : colors.text.secondary,
    borderBottom: isActive
      ? `2px solid ${colors.primary.main}`
      : "2px solid transparent",
    borderRadius: 0,
    minWidth: "auto",

    "&:hover": {
      backgroundColor: colors.background.lightBlue,
    },
  }),
);
